import React, { Component } from 'react';
import { VKShareButton, VKIcon, TwitterShareButton, TwitterIcon, FacebookShareButton, FacebookIcon } from 'react-share'
import './share.css'
import { sendEvent } from '../../helpers/analytics'

class Social extends Component {

  render () {
    const url = window.location.href
    return (
      <div className="share">
        <VKShareButton url={url} >
          <span onClick={() => sendEvent('main', 'click', 'share-vk')}>
            <VKIcon iconBgStyle={{fill: 'transparent'}} />
          </span>
        </VKShareButton>

        <TwitterShareButton url={url} >
          <span onClick={() => sendEvent('main', 'click', 'share-twitter')}>
            <TwitterIcon iconBgStyle={{fill: 'transparent'}} />
          </span>
        </TwitterShareButton>

        <FacebookShareButton url={url} >
          <span onClick={() => sendEvent('main', 'click', 'share-fb')}>
            <FacebookIcon iconBgStyle={{fill: 'transparent'}} />
          </span>
        </FacebookShareButton>
      </div>
    )
  }
}

export default Social


// WEBPACK FOOTER //
// ./src/components/social/social.js